exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-js-editor{width:100%;height:auto!important;min-height:300px}.wangEditor-fullscreen{overflow-y:auto;padding-top:32px!important}.wangEditor-fullscreen .wangEditor-menu-container{position:fixed;top:0;left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-325c6a68","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/VueJsEditor.vue
// module id = 9
// module chunks = 0